import { axios as client } from './apiAdmin'
export const creatorConnectionsApi = {
    getSellerConnections: data => {
    return client.get('seller/cc/authorization/list', { params: data }).then(res => res)
    },
    getBrandConnections: data => {
        return client.get('seller/cc/brand/authorization/list', { params: data }).then(res => res)
    },
    //接受
    acceptConnection: data => {
        return client.post('seller/cc/authorization/accept', data).then(res => res)
    },
    //完成
    authorizeConnection: data => {
        return client.post('seller/cc/authorization/authorize', data).then(res => res)
    },
    //同步
    syncConnection: data => {
        return client.post('seller/cc/brand/authorization/authorize', data).then(res => res)
    },
    brandSearch: data => {
        return client.get('brand/search', { params: data }).then(res => res)
    },
    ccConfigeTextUpdate: data => {
        return client.post('cc/config/cookie/update-text', data, { headers: { 'Content-Type': 'text/plain' } }).then(res => res)
    },
    ccConfigeTextCheck: data => {
        return client.get('cc/config/cookie/check', data).then(res => res)
    },
    retrySyncItem:data => {
        return client.post(`seller/cc/brand/authorization/retry-sync`, data).then(res => res)
    },
    retrySyncAll:data => {
        return client.post(`seller/cc/brand/authorization/retry-sync-all`, data).then(res => res)
    },
    getCampaignReportList: data => {
        return client.get('cc/campaign/list', { params: data }).then(res => res)
    },
    ccCampaignSync: data => {
        return client.post('cc/campaign/sync', data).then(res => res)
    },
    ccBrandSync: data => {
        return client.post('cc/campaign/report/sync', data).then(res => res)
    },
}